<form [formGroup]="underwritingDecisionForm">
  <div>
    <div class="heading-tab">
      <h3 *ngIf="appMetadataHandler.APPCONSTANTS.nbuDefaultState!='proposal_ManualUw'" class="heading">
        <i nz-icon nzType="file-text"></i> Claim Decision</h3>
      <h3 *ngIf="appMetadataHandler.APPCONSTANTS.nbuDefaultState=='proposal_ManualUw'" class="heading">
        <i nz-icon nzType="file-text"></i> Underwriting Decision for Policy</h3>
    </div>
    <div class="tab-grid m-t-20">
      <nz-form-item>
        <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('underwritingDecision')">Decision</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <nz-select nzShowSearch nzAllowClear style="width: 100%" formControlName="underwritingDecision"
            (ngModelChange)='updateDecisionSelect()'>
            <nz-option *ngFor="let item of (lookup$['uwDecisionCd'] | async) as manualUwDecisionCd;"
              [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
          </nz-select>
          <nz-form-explain *ngIf="(underwritingDecisionForm.get('underwritingDecision').dirty || 
            underwritingDecisionForm.get('underwritingDecision').touched) && 
            underwritingDecisionForm.get('underwritingDecision').errors">
          <p style="color:red"
              *ngFor="let error of validationUtilService.getUIErrorList(underwritingDecisionForm.get('underwritingDecision'),UNDERWRITINGDECISIONFORM)">
              {{error.errorMessage}}</p>
          </nz-form-explain>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('underwritingRemarks')">Remarks</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <textarea nz-input cols="30" rows="4" placeholder="{{'Enter your notes'| translate}}..."
            formControlName="underwritingNote" formControlName="underwritingRemarks"></textarea>
          <p style="font-size: xx-small;">
            {{underwritingDecisionForm.get('underwritingRemarks').value? underwritingDecisionForm.get('underwritingRemarks').value.length: 0}}/2000
            Characters</p>
          <nz-form-explain *ngIf="(underwritingDecisionForm.get('underwritingRemarks').dirty || 
            underwritingDecisionForm.get('underwritingRemarks').touched) && 
            underwritingDecisionForm.get('underwritingRemarks').errors">
            <p style="color:red"
                *ngFor="let error of validationUtilService.getUIErrorList(underwritingDecisionForm.get('underwritingRemarks'),UNDERWRITINGDECISIONFORM)">
                {{error.errorMessage}}</p>
          </nz-form-explain>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div *ngIf="underwritingDecisionForm?.value?.underwritingDecision === 'RATED'" class="tab-grid m-t-20">
      <nz-form-item>
        <nz-form-label [nzSpan]="24">Rated Decision</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <nz-select nzShowSearch [(ngModel)]="ratedTypeCd">
            <nz-option [nzLabel]="'Flat Extra'" [nzValue]="'Flat Extra'"></nz-option>
            <nz-option [nzLabel]="'Percent Extra'" [nzValue]="'Percent Extra'"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSpan]="24">Extra Value</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input type="text" nz-input placeholder="Enter extra value" />
        </nz-form-control>
      </nz-form-item>
    </div>


    <ng-container *ngIf="rulesData && rulesData.length > 0">
      <nz-table [nzData]="[1]" [nzShowPagination]="false">
        <thead class="table-header">
          <tr>
            <th class="">Rule Name</th>
            <!-- <th class="">Rule SubType</th>
            <th class="">Decision Type</th> -->
            <th class="">Decision</th>
            <!-- <th class="">Decision Value</th> -->
            <th class="">Weight</th>
            <th class="">Recommendation</th>
          </tr>
        </thead>
        <tbody class="">
          <!-- ruleName,ruleSubType,entityGuid,decisionType,decision,decisionValue -->
          <tr class="table-row" *ngFor="let rule of rulesData">
            <td class="">{{rule.ruleName}}</td>
            <!-- <td class="">{{rule.ruleSubType}}</td>
            <td class="">{{rule.decisionType}}</td> -->
            <td class="">{{rule.decision}}</td>
            <!-- <td class="">{{rule.decisionValue}}</td> -->
            <td class="">{{rule.weight}}</td>
            <td class="">{{rule.recco}}</td>
          </tr>
        </tbody>
      </nz-table>
    </ng-container>

  </div>
</form>
